import { render, staticRenderFns } from "./App.vue?vue&type=template&id=4fa19c31"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"
import style0 from "./App.vue?vue&type=style&index=0&id=4fa19c31&prod&lang=sass"
import style1 from "./App.vue?vue&type=style&index=1&id=4fa19c31&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports